import { z } from "zod";
import zodToCamelCase from "zod-to-camel-case";

import { safeString } from "@/schema/public/components/base/safe-string.schema";

export const misconceptionsAndCommonMistakesSchema = z.object({
  misconception: safeString,
  response: safeString,
});

export type MisconceptionsAndCommonMistakes = z.infer<
  typeof misconceptionsAndCommonMistakesSchema
>;

export const misconceptionsAndCommonMistakesSchemaCamel = zodToCamelCase(
  misconceptionsAndCommonMistakesSchema,
);
export type MisconceptionsAndCommonMistakesCamel = z.infer<
  typeof misconceptionsAndCommonMistakesSchemaCamel
>;
